/** Session-scoped reference height; shared by local rendering and network publishing. */
let revision = 0;
const sessions = new WeakMap<object, { revision: number; started: number; height: number }>();
export function requestAvatarCalibration() { revision++; }
export function sampleAvatarHeight(session: object, height: number, now: number): number | undefined {
  if (!Number.isFinite(height) || height < .65 || height > 2.5) return undefined;
  let state = sessions.get(session);
  if (!state || state.revision !== revision) {
    state = { revision, started: now, height }; sessions.set(session, state);
  } else if (now - state.started < 2000) state.height = Math.max(state.height, height);
  return state.height;
}
